import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const StaffDeleteOrgModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "StaffDeleteOrgModalContainer" */
      './StaffDeleteOrgModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
